import { Fragment } from 'react'
import { InputLabel, TextInput, WithTheme } from '@opallabs/lapidary'
import * as styles from '../styles'

export type TransformContentProps = WithTheme & {
  initialPrompt?: string
  label: string
  onChange: (value: string) => void
  placeholder: string
}

export const TransformContentInput: React.FC<TransformContentProps> = ({
  initialPrompt = '',
  label,
  onChange,
  placeholder,
  theme = 'dark',
}) => {
  return (
    <Fragment>
      <InputLabel
        required={false}
        text={label}
        theme={theme}
        styleOverrides={styles.labelOverrides}
      />
      <TextInput
        initialValue={initialPrompt}
        minLength={1}
        onChange={onChange}
        theme={theme}
        placeholder={placeholder}
      />
    </Fragment>
  )
}
